import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

export type FilterStatuses =
  | 'error'
  | 'missingName'
  | 'missingLastName'
  | 'invalidEmail'
  | 'invalidSeniorityCalculationDate'
  | 'unrecognizedLegalEntity'
  | 'unrecognizedWorkplace'
  | 'unrecognizedTeams'
  | 'unrecognizedNationality'
  | 'invalidContractStartDate'
  | 'unrecognizedJobLevel'
  | 'selectedRows'
  | 'ignoredRows'
  | 'invalidPostalCode'
  | 'invalidBirthdayOn'
  | 'invalidContactName'
  | 'invalidContactNumber'
  | 'invalidPhoneNumber'
  | 'invalidAddressLine1'
  | 'invalidCity'
  | 'invalidState'
  | 'unrecognizedCountry'
  | 'invalidA3InnuvaCode'
  | 'invalidA3NomCode'
  | 'invalidSalaryAmountInCents'
  | 'invalidEndsOnDate'
  | 'invalidWorkingHours'
  | undefined

type FilterStatusWithoutUndefined = Exclude<FilterStatuses, undefined>

export interface Props {
  onChangeFilter: (value: FilterStatuses) => void
  filterStatus: FilterStatuses | undefined
  count: { [key in FilterStatusWithoutUndefined]: number | undefined }
}

const Filters = ({ onChangeFilter, filterStatus, count }: Props) => {
  const options = [
    {
      label: `${i18n.t('importer_process.edition_step.filters.rows.options.error')} (${
        count.error
      })`,
      value: 'error',
    },
    {
      label: `${i18n.t('importer_process.edition_step.filters.rows.options.missing_name')}(${
        count.missingName
      })`,
      value: 'missingName',
    },
    {
      label: `${i18n.t('importer_process.edition_step.filters.rows.options.missing_last_name')} (${
        count.missingLastName
      })`,
      value: 'missingLastName',
    },
    {
      label: `${i18n.t('importer_process.edition_step.filters.rows.options.invalid_email')}(${
        count.invalidEmail
      })`,
      value: 'invalidEmail',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.unrecognized_legal_entity'
      )} (${count.unrecognizedLegalEntity})`,
      value: 'unrecognizedLegalEntity',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.unrecognized_location'
      )} (${count.unrecognizedWorkplace})`,
      value: 'unrecognizedWorkplace',
    },
    {
      label: `${i18n.t('importer_process.edition_step.filters.rows.options.unrecognized_team')} (${
        count.unrecognizedTeams
      })`,
      value: 'unrecognizedTeams',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_seniority_calculation_date'
      )}(${count.invalidSeniorityCalculationDate})`,
      value: 'invalidSeniorityCalculationDate',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_contract_start_date'
      )}(${count.invalidContractStartDate})`,
      value: 'invalidContractStartDate',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.unrecognized_job_level'
      )} (${count.unrecognizedJobLevel})`,
      value: 'unrecognizedJobLevel',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.unrecognized_nationality'
      )} (${count.unrecognizedNationality})`,
      value: 'unrecognizedNationality',
    },
    {
      label: `${i18n.t('importer_process.edition_step.filters.rows.options.selected_rows')} (${
        count.selectedRows
      })`,
      value: 'selectedRows',
    },
    {
      label: `${i18n.t('importer_process.edition_step.filters.rows.options.ignored_rows')} (${
        count.ignoredRows
      })`,
      value: 'ignoredRows',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_postal_code'
      )} (${count.invalidPostalCode})`,
      value: 'invalidPostalCode',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_birthday_on'
      )} (${count.invalidBirthdayOn})`,
      value: 'invalidBirthdayOn',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_contact_name'
      )} (${count.invalidContactName})`,
      value: 'invalidContactName',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_contact_number'
      )} (${count.invalidContactNumber})`,
      value: 'invalidContactNumber',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_phone_number'
      )} (${count.invalidPhoneNumber})`,
      value: 'invalidPhoneNumber',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_address_line1'
      )} (${count.invalidAddressLine1})`,
      value: 'invalidAddressLine1',
    },
    {
      label: `${i18n.t('importer_process.edition_step.filters.rows.options.invalid_city')} (${
        count.invalidCity
      })`,
      value: 'invalidCity',
    },
    {
      label: `${i18n.t('importer_process.edition_step.filters.rows.options.invalid_state')} (${
        count.invalidState
      })`,
      value: 'invalidState',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.unrecognized_country'
      )} (${count.unrecognizedCountry})`,
      value: 'unrecognizedCountry',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_a3_innuva_code'
      )} (${count.invalidA3InnuvaCode})`,
      value: 'invalidA3InnuvaCode',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_a3_nom_code'
      )} (${count.invalidA3NomCode})`,
      value: 'invalidA3NomCode',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_salary_amount_in_cents'
      )} (${count.invalidSalaryAmountInCents})`,
      value: 'invalidSalaryAmountInCents',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_ends_on_date'
      )} (${count.invalidEndsOnDate})`,
      value: 'invalidEndsOnDate',
    },
    {
      label: `${i18n.t(
        'importer_process.edition_step.filters.rows.options.invalid_working_hours'
      )} (${count.invalidWorkingHours})`,
      value: 'invalidWorkingHours',
    },
  ]

  return (
    <Filter.SingleChoice
      label={i18n.t('importer_process.edition_step.filters.rows.label')}
      options={options}
      // eslint-disable-next-line no-type-assertion/no-type-assertion
      onValueChange={(value) => onChangeFilter((value as FilterStatuses) || undefined)}
      value={filterStatus}
    />
  )
}

export default Filters
